require('./angular-route');
module.exports = 'ngRoute';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-route/index.js
 ** module id = 324
 ** module chunks = 1
 **/